import { useEffect } from "react"

function TurnstileComponent({ callback }: { callback: (token: string) => void }) {

    useEffect(() => {
        //@ts-ignore
        turnstile.render("#custom-turnstile", {
            sitekey: '0x4AAAAAAAIcH5xTc-Ea22gR',
            callback: function (token: string) {
                callback(token);
            },
        });
    }, []);

    return (
        <div id='custom-turnstile'></div>
    )
}

export default TurnstileComponent